import { render, staticRenderFns } from "./CardPainel.vue?vue&type=template&id=68cdca68&"
import script from "./CardPainel.js?vue&type=script&lang=js&"
export * from "./CardPainel.js?vue&type=script&lang=js&"
import style0 from "./CardPainel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
